// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1Vsk3","search":"Settings_search__3uji-","filter":"Settings_filter__Np6cs"};